import { Link } from "@tanstack/react-router";
import type { LinkProps } from "@tanstack/react-router";
import { forwardRef } from "react";
import type { AnchorHTMLAttributes } from "react";

/**
 * Adapter that bridges Compass's `LinkComponent` interface (which passes
 * `href`) to TanStack Router's `Link` (which expects `to`).
 *
 * Use this anywhere Circle needs to pass a router-aware link into a
 * Compass component that accepts `linkComponent` (Button, IconButton,
 * Tabs, etc.) for client-side navigation.
 */
export const RouterLink = forwardRef<
  HTMLAnchorElement,
  AnchorHTMLAttributes<HTMLAnchorElement> & Pick<LinkProps, "preload">
>(({ href, ...props }, ref) => <Link ref={ref} to={href ?? ""} {...props} />);

RouterLink.displayName = "RouterLink";
